module.exports = __webpack_public_path__ + "img/4.41ea07fe.svg";